"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SequencerInbox__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_maxDataSize",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "AlreadyInit",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "AlreadyValidDASKeyset",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "stored",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "received",
                type: "uint256",
            },
        ],
        name: "BadSequencerNumber",
        type: "error",
    },
    {
        inputs: [],
        name: "DataNotAuthenticated",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxDataLength",
                type: "uint256",
            },
        ],
        name: "DataTooLarge",
        type: "error",
    },
    {
        inputs: [],
        name: "DelayedBackwards",
        type: "error",
    },
    {
        inputs: [],
        name: "DelayedTooFar",
        type: "error",
    },
    {
        inputs: [],
        name: "ForceIncludeBlockTooSoon",
        type: "error",
    },
    {
        inputs: [],
        name: "ForceIncludeTimeTooSoon",
        type: "error",
    },
    {
        inputs: [],
        name: "HadZeroInit",
        type: "error",
    },
    {
        inputs: [],
        name: "IncorrectMessagePreimage",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "NoSuchKeyset",
        type: "error",
    },
    {
        inputs: [],
        name: "NotBatchPoster",
        type: "error",
    },
    {
        inputs: [],
        name: "NotForked",
        type: "error",
    },
    {
        inputs: [],
        name: "NotOrigin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "NotOwner",
        type: "error",
    },
    {
        inputs: [],
        name: "RollupNotChanged",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "messageNum",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "InboxMessageDelivered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "messageNum",
                type: "uint256",
            },
        ],
        name: "InboxMessageDeliveredFromOrigin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "keysetHash",
                type: "bytes32",
            },
        ],
        name: "InvalidateKeyset",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "OwnerFunctionCalled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "batchSequenceNumber",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "SequencerBatchData",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "batchSequenceNumber",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "beforeAcc",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "afterAcc",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "delayedAcc",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "afterDelayedMessagesRead",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint64",
                        name: "minTimestamp",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "maxTimestamp",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "minBlockNumber",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "maxBlockNumber",
                        type: "uint64",
                    },
                ],
                indexed: false,
                internalType: "struct ISequencerInbox.TimeBounds",
                name: "timeBounds",
                type: "tuple",
            },
            {
                indexed: false,
                internalType: "enum ISequencerInbox.BatchDataLocation",
                name: "dataLocation",
                type: "uint8",
            },
        ],
        name: "SequencerBatchDelivered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "keysetHash",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "keysetBytes",
                type: "bytes",
            },
        ],
        name: "SetValidKeyset",
        type: "event",
    },
    {
        inputs: [],
        name: "DATA_AUTHENTICATED_FLAG",
        outputs: [
            {
                internalType: "bytes1",
                name: "",
                type: "bytes1",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "HEADER_LENGTH",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "sequenceNumber",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "afterDelayedMessagesRead",
                type: "uint256",
            },
            {
                internalType: "contract IGasRefunder",
                name: "gasRefunder",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "prevMessageCount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "newMessageCount",
                type: "uint256",
            },
        ],
        name: "addSequencerL2Batch",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "sequenceNumber",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "afterDelayedMessagesRead",
                type: "uint256",
            },
            {
                internalType: "contract IGasRefunder",
                name: "gasRefunder",
                type: "address",
            },
        ],
        name: "addSequencerL2BatchFromOrigin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "sequenceNumber",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "afterDelayedMessagesRead",
                type: "uint256",
            },
            {
                internalType: "contract IGasRefunder",
                name: "gasRefunder",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "prevMessageCount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "newMessageCount",
                type: "uint256",
            },
        ],
        name: "addSequencerL2BatchFromOrigin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "batchCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bridge",
        outputs: [
            {
                internalType: "contract IBridge",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "dasKeySetInfo",
        outputs: [
            {
                internalType: "bool",
                name: "isValidKeyset",
                type: "bool",
            },
            {
                internalType: "uint64",
                name: "creationBlock",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_totalDelayedMessagesRead",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "kind",
                type: "uint8",
            },
            {
                internalType: "uint64[2]",
                name: "l1BlockAndTime",
                type: "uint64[2]",
            },
            {
                internalType: "uint256",
                name: "baseFeeL1",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "messageDataHash",
                type: "bytes32",
            },
        ],
        name: "forceInclusion",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "ksHash",
                type: "bytes32",
            },
        ],
        name: "getKeysetCreationBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "inboxAccs",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IBridge",
                name: "bridge_",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "delayBlocks",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "futureBlocks",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "delaySeconds",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "futureSeconds",
                        type: "uint256",
                    },
                ],
                internalType: "struct ISequencerInbox.MaxTimeVariation",
                name: "maxTimeVariation_",
                type: "tuple",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "ksHash",
                type: "bytes32",
            },
        ],
        name: "invalidateKeysetHash",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "isBatchPoster",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "isSequencer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "ksHash",
                type: "bytes32",
            },
        ],
        name: "isValidKeysetHash",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "maxDataSize",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "maxTimeVariation",
        outputs: [
            {
                internalType: "uint256",
                name: "delayBlocks",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "futureBlocks",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "delaySeconds",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "futureSeconds",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "removeDelayAfterFork",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rollup",
        outputs: [
            {
                internalType: "contract IOwnable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
            {
                internalType: "bool",
                name: "isBatchPoster_",
                type: "bool",
            },
        ],
        name: "setIsBatchPoster",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
            {
                internalType: "bool",
                name: "isSequencer_",
                type: "bool",
            },
        ],
        name: "setIsSequencer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "delayBlocks",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "futureBlocks",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "delaySeconds",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "futureSeconds",
                        type: "uint256",
                    },
                ],
                internalType: "struct ISequencerInbox.MaxTimeVariation",
                name: "maxTimeVariation_",
                type: "tuple",
            },
        ],
        name: "setMaxTimeVariation",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "keysetBytes",
                type: "bytes",
            },
        ],
        name: "setValidKeyset",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "totalDelayedMessagesRead",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "updateRollupAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class SequencerInbox__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "SequencerInbox";
    }
    deploy(_maxDataSize, overrides) {
        return super.deploy(_maxDataSize, overrides || {});
    }
    getDeployTransaction(_maxDataSize, overrides) {
        return super.getDeployTransaction(_maxDataSize, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.SequencerInbox__factory = SequencerInbox__factory;
SequencerInbox__factory.bytecode = _bytecode;
SequencerInbox__factory.abi = _abi;
